import { API_URL } from "../utils/Constant";
import axiosInstance from "../utils/axiosInstance";
import { setAccessToken } from '../app/slice/authSlice';
import jwtDecode from "jwt-decode";
import {  generateKeyPair } from "../utils/utils";
import { store } from "../app/store";

export async function loginUser(creds) {
  try {
    const response = await axiosInstance.post("/user/login/", creds);
    const accessToken = response.data.access;
    const decodedToken = jwtDecode(accessToken);
    if (!decodedToken.public_key) {
      const { publicKeyPem, privateKeyPem } = await generateKeyPair();
      localStorage.setItem("publickey", publicKeyPem)
      localStorage.setItem("privatekey", privateKeyPem)
      await fetch(API_URL + "/generate-key/", {
        method: "post",
        body: JSON.stringify({ public_key: publicKeyPem, private_key: privateKeyPem }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }
    return { data: response.data, res: response };
  } catch (error) {
    if (error.response) {
      const { data, statusText, status } = error.response;
      const customError = new Error(data.error || data.detail || statusText);
      customError.statusText = statusText;
      customError.status = status;
      customError.data = data;
      throw customError;
    } else if (error.request) {
      throw new Error('No response received from the server');
    } else {
      throw new Error('Error setting up the request');
    }
  }
}

export async function signupCompany(creds) {
  const { publicKeyPem, privateKeyPem } = await generateKeyPair();
  localStorage.setItem("publickey", publicKeyPem)
  localStorage.setItem("privatekey", privateKeyPem)
  const res = await fetch(API_URL + "/company/create/", {
    method: "post",
    body: JSON.stringify({ ...creds, public_key: publicKeyPem, private_key: privateKeyPem }),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await res.json();

  if (!res.ok) {
    throw data;
  }
  return { data, res };
}

export async function signupUser(creds, accessToken) {
  const { publicKeyPem, privateKeyPem } = await generateKeyPair();
  localStorage.setItem("publickey", publicKeyPem)
  localStorage.setItem("privatekey", privateKeyPem)

  const res = await fetch(API_URL + "/user/signup/", {
    method: "post",
    body: JSON.stringify({ ...creds, public_key: publicKeyPem, private_key: privateKeyPem }),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.detail);
    error.statusText = res.statusText;
    error.status = res.status;
    throw data;
  }
  return { data, res };
}

export async function resetPassword(creds) {
  const res = await fetch(API_URL + "/user/set_password/", {
    method: "post",
    body: JSON.stringify(creds),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await res.json();

  return { data, res };
}
export async function forgotPassword(creds) {
  try {
    const response = await axiosInstance.post(`/user/${creds.email}/forgot_password/`, {});
    return { data: response.data, res: response };
  } catch (error) {
    return { data: error.response.data, res: error.response };
  }
}

export async function sendPassword(creds) {
  try {
    const response = await axiosInstance.post(
      `/user/${creds.userId}/send-reset-password-link/`,
      null
    );

    return { data: response.data, res: response };
  } catch (error) {
    return { error };
  }
}

export async function sendRequestDemo(creds) {
  try {
    const response = await axiosInstance.post(`/company/demo-request/`, creds.data)
    return { data: response.data, res: response };
  } catch (error) {
    return { error };
  }
}


export async function getConstants(creds) {
  const res = await fetch(API_URL + "/get_constants/", {
    method: "post",
    body: JSON.stringify(creds),
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.detail);
    error.statusText = res.statusText;
    error.status = res.status;
    throw error;
  }

  return { data, res };
}

export const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await fetch(`${API_URL}/token/refresh/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!response.ok) {
      throw new Error('Failed to refresh access token');
    }

    const data = await response.json();

    // Update the access token in local storage
    store.dispatch( setAccessToken(data.access) );

    return data.access;
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw error;
  }
};